/* ═══════════════════════════════════════════════════════════════
   CART DRAWER — Premium v3 (Self-Contained)
   ColdLasers.org
   Single file: injects own CSS + builds HTML + handles all logic
   Replace your current cart-drawer.js with this file entirely.
   You can also delete the old cart-drawer.css — this handles everything.
   ═══════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ─── Inject Styles ─── */
  var s = document.createElement('style');
  s.id = 'cd-prem-css';
  s.textContent = [

  /* Body lock */
  'body.drawer-open{overflow:hidden!important}',

  /* Backdrop */
  '.cd-bk{position:fixed;inset:0;background:rgba(15,23,42,0.45);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);z-index:9998;opacity:0;transition:opacity .4s cubic-bezier(.22,1,.36,1);pointer-events:none}',
  'body.drawer-open .cd-bk{opacity:1;pointer-events:auto}',

  /* Panel */
  '#CartDrawer{position:fixed!important;top:0!important;right:0!important;bottom:0!important;left:auto!important;width:430px!important;max-width:94vw!important;height:100%!important;background:#fff!important;box-shadow:-24px 0 80px rgba(15,23,42,.12),-6px 0 20px rgba(15,23,42,.06)!important;transform:translateX(102%)!important;transition:transform .45s cubic-bezier(.22,1,.36,1)!important;z-index:10000!important;display:flex!important;flex-direction:column!important;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif!important;-webkit-font-smoothing:antialiased!important;pointer-events:none!important;padding:0!important;margin:0!important;border:none!important;border-radius:0!important;overflow:hidden!important}',
  '#CartDrawer.open{transform:translateX(0)!important;pointer-events:auto!important}',

  /* Header */
  '.cd-hd{display:flex;align-items:center;justify-content:space-between;padding:18px 22px;border-bottom:1px solid #e2e8f0;background:#fff;flex-shrink:0}',
  '.cd-hd-l{display:flex;align-items:center;gap:12px}',
  '.cd-hd-badge{width:38px;height:38px;display:flex;align-items:center;justify-content:center;background:#EEF2FF;border-radius:10px;color:#3B6BF5;flex-shrink:0}',
  '.cd-hd-badge svg{width:20px;height:20px;display:block}',
  '.cd-hd h2{font-size:16px;font-weight:800;color:#0f172a;margin:0;line-height:1.2;letter-spacing:-.3px}',
  '.cd-hd-cnt{font-size:12px;font-weight:500;color:#64748b;display:block;margin-top:1px}',
  '.cd-x{display:flex;align-items:center;justify-content:center;width:34px;height:34px;border:1px solid #e2e8f0;border-radius:50%;background:#f8fafc;color:#64748b;cursor:pointer;padding:0;transition:all .25s cubic-bezier(.22,1,.36,1);font-size:0;line-height:1}',
  '.cd-x svg{width:18px;height:18px;display:block}',
  '.cd-x:hover{background:#0f172a;color:#fff;border-color:#0f172a;transform:rotate(90deg)}',

  /* Ship banner */
  '.cd-sb{display:flex;align-items:center;justify-content:center;gap:8px;padding:10px 22px;background:#ecfdf5;border-bottom:1px solid #a7f3d0;flex-shrink:0;font-size:12px;font-weight:700;color:#065f46;letter-spacing:.2px}',
  '.cd-sb svg{color:#10b981;width:16px;height:16px;flex-shrink:0;display:block}',

  /* Body scroll */
  '.cd-bd{flex:1;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}',
  '.cd-bd::-webkit-scrollbar{width:3px}',
  '.cd-bd::-webkit-scrollbar-track{background:transparent}',
  '.cd-bd::-webkit-scrollbar-thumb{background:#e2e8f0;border-radius:99px}',

  /* Empty */
  '.cd-mt{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:60px 32px;min-height:320px}',
  '.cd-mt-ring{width:88px;height:88px;display:flex;align-items:center;justify-content:center;background:#f8fafc;border:2px dashed #e2e8f0;border-radius:50%;color:#94a3b8;margin-bottom:20px}',
  '.cd-mt-ring svg{width:42px;height:42px;display:block}',
  '.cd-mt h3{font-size:17px;font-weight:800;color:#0f172a;margin:0 0 6px;letter-spacing:-.3px}',
  '.cd-mt p{font-size:13px;color:#64748b;margin:0 0 24px;max-width:260px;line-height:1.55}',
  '.cd-mt a{display:inline-flex;align-items:center;gap:6px;padding:12px 24px;background:#3B6BF5;color:#fff!important;font-size:13px;font-weight:700;text-decoration:none;border-radius:10px;transition:all .2s cubic-bezier(.22,1,.36,1);box-shadow:0 2px 8px rgba(59,107,245,.3)}',
  '.cd-mt a svg{width:14px;height:14px;display:block}',
  '.cd-mt a:hover{background:#2B55D4;transform:translateY(-1px);box-shadow:0 6px 20px rgba(59,107,245,.3);color:#fff!important}',

  /* Items */
  '.cd-it{display:grid!important;grid-template-columns:84px 1fr!important;gap:14px!important;padding:16px 22px!important;border-bottom:1px solid #f1f5f9!important;position:relative;transition:background .15s;align-items:start!important;animation:cdI .3s cubic-bezier(.22,1,.36,1) both}',
  '.cd-it:hover{background:#f8fafc}',
  '.cd-it:nth-child(1){animation-delay:0s}.cd-it:nth-child(2){animation-delay:.04s}.cd-it:nth-child(3){animation-delay:.08s}.cd-it:nth-child(4){animation-delay:.12s}.cd-it:nth-child(5){animation-delay:.16s}',
  '@keyframes cdI{from{opacity:0;transform:translateX(24px)}to{opacity:1;transform:translateX(0)}}',
  '.cd-it--rm{animation:cdO .3s cubic-bezier(.22,1,.36,1) forwards!important;overflow:hidden}',
  '@keyframes cdO{0%{opacity:1;max-height:200px}50%{opacity:0;transform:translateX(40px)}100%{opacity:0;max-height:0;padding-top:0;padding-bottom:0;border-bottom-width:0}}',

  /* Item image */
  '.cd-img{width:84px!important;height:84px!important;object-fit:contain!important;background:#f8fafc!important;border:1px solid #e2e8f0!important;border-radius:10px!important;padding:4px!important;transition:border-color .15s;display:block!important}',
  '.cd-it:hover .cd-img{border-color:#94a3b8!important}',

  /* Item details */
  '.cd-inf{display:flex;flex-direction:column;min-width:0}',
  '.cd-inf-top{display:flex;justify-content:space-between;align-items:flex-start;gap:8px}',
  '.cd-inf-ttl{font-size:14px!important;font-weight:700!important;color:#0f172a!important;line-height:1.35;margin:0!important;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;letter-spacing:-.15px}',
  '.cd-inf-ttl a{color:inherit!important;text-decoration:none!important;transition:color .15s}',
  '.cd-inf-ttl a:hover{color:#3B6BF5!important}',
  '.cd-inf-var{font-size:12px;color:#64748b;margin:2px 0 0}',

  /* Delete */
  '.cd-rm{display:flex;align-items:center;justify-content:center;width:26px;height:26px;min-width:26px;background:transparent;border:1px solid transparent;color:#94a3b8;cursor:pointer;border-radius:6px;flex-shrink:0;transition:all .15s;padding:0;font-size:0;line-height:1}',
  '.cd-rm svg{width:14px;height:14px;display:block}',
  '.cd-rm:hover{background:#fef2f2;border-color:#fecaca;color:#ef4444}',

  /* Bottom row */
  '.cd-inf-bot{display:flex;justify-content:space-between;align-items:center;margin-top:10px}',
  '.cd-pr{font-size:15px!important;font-weight:800!important;color:#0f172a!important;letter-spacing:-.3px;margin:0!important}',

  /* Qty */
  '.cd-qt{display:inline-flex!important;align-items:center!important;border:1.5px solid #e2e8f0!important;border-radius:8px!important;overflow:hidden!important;height:34px!important;gap:0!important;margin:0!important;transition:border-color .15s;background:#fff!important}',
  '.cd-qt:hover{border-color:#94a3b8!important}',
  '.cd-qt-b{display:flex!important;align-items:center!important;justify-content:center!important;width:34px!important;height:100%!important;background:#f8fafc!important;border:none!important;color:#334155!important;cursor:pointer!important;font-size:16px!important;font-weight:400!important;font-family:inherit!important;transition:background .12s,color .12s;padding:0!important;border-radius:0!important;line-height:1!important}',
  '.cd-qt-b:hover{background:#EEF2FF!important;color:#3B6BF5!important}',
  '.cd-qt-b:active{background:#dbeafe!important}',
  '.cd-qt-v{width:36px!important;text-align:center!important;font-size:13px!important;font-weight:700!important;color:#0f172a!important;border:none!important;border-left:1.5px solid #e2e8f0!important;border-right:1.5px solid #e2e8f0!important;background:#fff!important;outline:none!important;line-height:34px!important;height:100%!important;-moz-appearance:textfield!important;padding:0!important}',
  '.cd-qt-v::-webkit-inner-spin-button,.cd-qt-v::-webkit-outer-spin-button{-webkit-appearance:none!important;margin:0!important}',

  /* Footer */
  '.cd-ft{padding:16px 22px 20px!important;border-top:1px solid #e2e8f0!important;background:#fff!important;flex-shrink:0;margin:0!important;position:static!important}',

  /* Note */
  '.cd-nt{margin-bottom:12px}',
  '.cd-nt-tg{display:inline-flex;align-items:center;gap:6px;background:none;border:none;cursor:pointer;font-size:12px;font-weight:600;color:#64748b;font-family:inherit;padding:4px 0;transition:color .15s}',
  '.cd-nt-tg svg{width:13px;height:13px;display:inline-block}',
  '.cd-nt-tg:hover{color:#3B6BF5}',
  '.cd-nt-bx{margin-top:8px}',
  '.cd-nt-bx textarea{width:100%;padding:10px 12px;border:1.5px solid #e2e8f0;border-radius:8px;font-size:13px;font-family:inherit;color:#0f172a;resize:none;outline:none;background:#f8fafc;transition:border-color .15s;box-sizing:border-box;line-height:1.4}',
  '.cd-nt-bx textarea:focus{border-color:#3B6BF5}',
  '.cd-nt-bx textarea::placeholder{color:#94a3b8}',
  '.cd-nt-sv{margin-top:6px;padding:6px 14px;background:#f8fafc;border:1.5px solid #e2e8f0;border-radius:6px;font-size:12px;font-weight:700;color:#0f172a;cursor:pointer;font-family:inherit;transition:all .15s}',
  '.cd-nt-sv:hover{border-color:#3B6BF5;color:#3B6BF5}',
  '.cd-nt-sv.ok{border-color:#10b981!important;color:#10b981!important;background:#ecfdf5!important}',

  /* Totals */
  '.cd-tot{display:flex;justify-content:space-between;align-items:center;padding:0 0 2px}',
  '.cd-tot-l{font-size:14px;font-weight:500;color:#64748b}',
  '.cd-tot-v{font-size:20px;font-weight:800;color:#0f172a;letter-spacing:-.5px}',
  '.cd-sr{display:flex;justify-content:space-between;align-items:center;font-size:13px;color:#64748b;font-weight:500;padding:4px 0}',
  '.cd-sf{display:inline-flex;align-items:center;gap:3px;font-size:12px;font-weight:800;color:#10b981}',
  '.cd-sf svg{width:13px;height:13px;display:inline-block}',
  '.cd-tx{font-size:11px;color:#94a3b8;text-align:right;margin:2px 0 0}',

  /* Checkout */
  '.cd-co{display:flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;width:100%!important;padding:14px 20px!important;margin-top:14px!important;background:#3B6BF5!important;color:#fff!important;font-size:15px!important;font-weight:800!important;text-decoration:none!important;border-radius:10px!important;box-shadow:0 4px 14px rgba(59,107,245,.3)!important;transition:all .25s cubic-bezier(.22,1,.36,1)!important;box-sizing:border-box!important;letter-spacing:.2px;border:none!important;cursor:pointer!important}',
  '.cd-co svg{width:16px;height:16px;flex-shrink:0;display:block}',
  '.cd-co:hover{background:#2B55D4!important;transform:translateY(-2px)!important;box-shadow:0 8px 24px rgba(59,107,245,.3)!important;color:#fff!important}',
  '.cd-co:active{transform:translateY(0)!important}',
  '.cd-co .cd-ar{transition:transform .2s cubic-bezier(.22,1,.36,1)}',
  '.cd-co:hover .cd-ar{transform:translateX(3px)}',

  /* View cart */
  '.cd-vc{display:block!important;text-align:center!important;margin-top:8px!important;padding:10px!important;font-size:12px!important;font-weight:700!important;color:#64748b!important;text-decoration:none!important;border:1.5px solid #e2e8f0!important;border-radius:10px!important;transition:all .15s;font-family:inherit}',
  '.cd-vc:hover{color:#0f172a!important;border-color:#94a3b8!important;background:#f8fafc!important}',

  /* Trust */
  '.cd-tr{display:flex;align-items:center;justify-content:center;gap:4px;margin-top:12px;padding-top:12px;border-top:1px solid #f1f5f9}',
  '.cd-tr-i{display:inline-flex;align-items:center;gap:3px;font-size:10px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:.5px}',
  '.cd-tr-i svg{width:13px;height:13px;color:#10b981;display:inline-block}',
  '.cd-tr-d{color:#e2e8f0;font-size:14px;margin:0 4px}',

  /* Responsive */
  '@media(max-width:480px){#CartDrawer{width:100vw!important;max-width:100vw!important}.cd-it{grid-template-columns:72px 1fr!important;gap:12px!important;padding:14px 16px!important}.cd-img{width:72px!important;height:72px!important}.cd-hd{padding:16px!important}.cd-ft{padding:14px 16px 18px!important}.cd-sb{padding:8px 16px!important}}'

  ].join('\n');

  var old = document.getElementById('cd-prem-css');
  if (old) old.remove();
  document.head.appendChild(s);

  /* SVG helper */
  function svg(d, sw) {
    return '<svg fill="none" stroke="currentColor" stroke-width="' + (sw||2) + '" viewBox="0 0 24 24">' + d + '</svg>';
  }
  var ICO = {
    bag: svg('<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/>', 1.8),
    x: svg('<path d="M18 6L6 18M6 6l12 12"/>'),
    truck: svg('<rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>'),
    arrow: svg('<path d="M5 12h14m-7-7l7 7-7 7"/>', 2.5),
    lock: svg('<rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/>'),
    check: svg('<polyline points="20 6 9 17 4 12"/>', 2.5),
    shield: svg('<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>'),
    badge: svg('<path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>'),
    phone: svg('<path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.11 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.362 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0122 16.92z"/>'),
    pen: svg('<path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>')
  };


  /* ═══════════ INIT ═══════════ */
  function init() {
    var D = document.getElementById('CartDrawer');
    if (!D) return;

    /* Backdrop */
    var bk = document.querySelector('.cd-bk');
    if (!bk) { bk = document.createElement('div'); bk.className = 'cd-bk'; document.body.appendChild(bk); }

    /* Build interior */
    D.innerHTML =
      '<div class="cd-hd">'
      + '<div class="cd-hd-l">'
      +   '<div class="cd-hd-badge">' + ICO.bag + '</div>'
      +   '<div><h2>Your Cart</h2><span class="cd-hd-cnt" id="CDCnt">0 items</span></div>'
      + '</div>'
      + '<button type="button" class="cd-x" id="CDX" aria-label="Close cart">' + ICO.x + '</button>'
      + '</div>'

      + '<div class="cd-sb" id="CDSb">' + ICO.truck + '<span id="CDSm">Free shipping on all orders</span></div>'

      + '<div class="cd-bd" id="CDBd">'
      +   '<div class="cd-mt" id="CDMt" style="display:none">'
      +     '<div class="cd-mt-ring">' + ICO.bag + '</div>'
      +     '<h3>Your cart is empty</h3>'
      +     '<p>Browse our collection and find the right laser therapy system for your practice.</p>'
      +     '<a href="/collections/all" id="CDGo">Shop All Products ' + ICO.arrow + '</a>'
      +   '</div>'
      +   '<div id="CDIs"></div>'
      + '</div>'

      + '<div class="cd-ft" id="CDFt" style="display:none">'
      +   '<div class="cd-nt">'
      +     '<button type="button" class="cd-nt-tg" id="CDNtT">' + ICO.pen + '<span id="CDNtL">Add order note</span></button>'
      +     '<div class="cd-nt-bx" id="CDNtB" style="display:none">'
      +       '<textarea id="CDNtI" placeholder="Special instructions, PO numbers, etc." rows="2" maxlength="250"></textarea>'
      +       '<button type="button" class="cd-nt-sv" id="CDNtS">Save Note</button>'
      +     '</div>'
      +   '</div>'
      +   '<div class="cd-tot"><span class="cd-tot-l">Subtotal</span><span class="cd-tot-v" id="CDTot">$0.00</span></div>'
      +   '<div class="cd-sr"><span>Shipping</span><span class="cd-sf">' + ICO.check + ' FREE</span></div>'
      +   '<p class="cd-tx">Tax calculated at checkout</p>'
      +   '<a href="/checkout" class="cd-co" id="CDCo">' + ICO.lock + '<span>Secure Checkout</span><span class="cd-ar">' + ICO.arrow + '</span></a>'
      +   '<a href="/cart" class="cd-vc">View Full Cart</a>'
      +   '<div class="cd-tr">'
      +     '<span class="cd-tr-i">' + ICO.shield + 'SSL Secure</span>'
      +     '<span class="cd-tr-d">&middot;</span>'
      +     '<span class="cd-tr-i">' + ICO.badge + 'Warranty</span>'
      +     '<span class="cd-tr-d">&middot;</span>'
      +     '<span class="cd-tr-i">' + ICO.phone + 'Support</span>'
      +   '</div>'
      + '</div>';

    /* Refs */
    var $is = document.getElementById('CDIs');
    var $mt = document.getElementById('CDMt');
    var $ft = document.getElementById('CDFt');
    var $tot = document.getElementById('CDTot');
    var $cnt = document.getElementById('CDCnt');
    var $sm = document.getElementById('CDSm');
    var $x = document.getElementById('CDX');
    var $go = document.getElementById('CDGo');
    var $ntT = document.getElementById('CDNtT');
    var $ntL = document.getElementById('CDNtL');
    var $ntB = document.getElementById('CDNtB');
    var $ntI = document.getElementById('CDNtI');
    var $ntS = document.getElementById('CDNtS');

    function open() {
      load();
      D.classList.add('open');
      D.setAttribute('aria-hidden','false');
      document.body.classList.add('drawer-open');
      setTimeout(function(){ $x.focus(); }, 150);
    }
    function close() {
      D.classList.remove('open');
      D.setAttribute('aria-hidden','true');
      document.body.classList.remove('drawer-open');
    }

    $x.addEventListener('click', close);
    bk.addEventListener('click', close);
    if ($go) $go.addEventListener('click', close);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && D.classList.contains('open')) close();
    });

    /* Fetch + render */
    function load() {
      fetch('/cart.js', { headers:{'Accept':'application/json'} })
        .then(function(r){ return r.json(); })
        .then(render)
        .catch(function(){});
    }

    function render(cart) {
      var items = cart.items || [], total = cart.total_price || 0, count = cart.item_count || 0;
      $cnt.textContent = count + (count === 1 ? ' item' : ' items');

      document.querySelectorAll('[data-cart-count]').forEach(function(el){
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });

      $sm.innerHTML = count > 0
        ? '<strong>Free shipping</strong> on your order \u00B7 Est. 2\u20133 business days'
        : 'Free shipping on all orders';

      if (!items.length) {
        $mt.style.display = '';
        $is.innerHTML = '';
        $ft.style.display = 'none';
        return;
      }

      $mt.style.display = 'none';
      $ft.style.display = '';

      var h = '';
      items.forEach(function(it) {
        var img = it.image ? it.image.replace(/(\.[^.]+)$/, '_240x$1') : '';
        var vr = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        h += '<div class="cd-it" data-k="' + it.key + '">'
          + '<img class="cd-img" src="' + img + '" alt="' + esc(it.product_title) + '" loading="lazy"/>'
          + '<div class="cd-inf">'
            + '<div class="cd-inf-top">'
              + '<div>'
                + '<p class="cd-inf-ttl"><a href="' + it.url + '">' + esc(it.product_title) + '</a></p>'
                + (vr ? '<p class="cd-inf-var">' + esc(vr) + '</p>' : '')
              + '</div>'
              + '<button class="cd-rm" data-k="' + it.key + '" aria-label="Remove">' + ICO.x + '</button>'
            + '</div>'
            + '<div class="cd-inf-bot">'
              + '<div class="cd-qt">'
                + '<button class="cd-qt-b" data-k="' + it.key + '" data-d="dn">\u2212</button>'
                + '<input type="number" class="cd-qt-v" value="' + it.quantity + '" readonly/>'
                + '<button class="cd-qt-b" data-k="' + it.key + '" data-d="up">+</button>'
              + '</div>'
              + '<p class="cd-pr">' + money(it.final_line_price) + '</p>'
            + '</div>'
          + '</div>'
        + '</div>';
      });
      $is.innerHTML = h;
      $tot.textContent = money(total);
      bind();

      if (cart.note) { $ntI.value = cart.note; $ntL.textContent = 'Edit order note'; }
      else { $ntL.textContent = 'Add order note'; }
    }

    /* Item listeners */
    function bind() {
      $is.querySelectorAll('.cd-qt-b').forEach(function(b){
        b.addEventListener('click', function(e){
          e.stopPropagation();
          var k = b.dataset.k, d = b.dataset.d;
          var row = b.closest('.cd-it');
          var inp = row.querySelector('.cd-qt-v');
          var q = parseInt(inp.value,10)||1;
          q = d === 'up' ? q+1 : q-1;
          if (q <= 0) {
            row.classList.add('cd-it--rm');
            setTimeout(function(){ upd(k,0); }, 300);
          } else {
            inp.value = q;
            upd(k, q);
          }
        });
      });
      $is.querySelectorAll('.cd-rm').forEach(function(b){
        b.addEventListener('click', function(e){
          e.stopPropagation();
          var row = b.closest('.cd-it');
          row.classList.add('cd-it--rm');
          setTimeout(function(){ upd(b.dataset.k, 0); }, 300);
        });
      });
    }

    function upd(k, q) {
      _cdInternal = true;
      fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id:k, quantity:q})
      }).then(function(r){ return r.json(); }).then(function(cart) {
        _cdInternal = false;
        render(cart);
      }).catch(function() {
        _cdInternal = false;
        load();
      });
    }

    /* Note */
    $ntT.addEventListener('click', function(){
      var h = $ntB.style.display === 'none';
      $ntB.style.display = h ? 'block' : 'none';
      if (h) $ntI.focus();
    });
    $ntS.addEventListener('click', function(){
      fetch('/cart/update.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({note: $ntI.value})
      }).then(function(){
        $ntS.textContent = '\u2713 Saved';
        $ntS.classList.add('ok');
        $ntL.textContent = $ntI.value ? 'Edit order note' : 'Add order note';
        setTimeout(function(){ $ntS.textContent = 'Save Note'; $ntS.classList.remove('ok'); }, 2000);
      });
    });

    /* Helpers */
    function money(c){ return '$'+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,','); }
    function esc(s){ var e=document.createElement('span'); e.textContent=s||''; return e.innerHTML; }

    /* ─── Monitor cart additions (don't intercept, just detect) ─── */
    /* Flag so our own internal calls don't re-trigger the drawer */
    var _cdInternal = false;

    var _origFetch = window.fetch;
    window.fetch = function() {
      var url = arguments[0] || '';
      var result = _origFetch.apply(this, arguments);

      /* Only auto-open for ADD requests, not our own qty changes */
      if (!_cdInternal && typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        result.then(function(resp) {
          return resp.clone().json();
        }).then(function() {
          setTimeout(function() { open(); }, 150);
        }).catch(function(){});
      }

      return result;
    };

    /* Also patch XMLHttpRequest for older themes */
    var _origXHROpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      this._cdUrl = url || '';
      return _origXHROpen.apply(this, arguments);
    };
    var _origXHRSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function() {
      var xhr = this;
      if (!_cdInternal && typeof xhr._cdUrl === 'string' && xhr._cdUrl.indexOf('/cart/add') !== -1) {
        xhr.addEventListener('load', function() {
          setTimeout(function() { open(); }, 150);
        });
      }
      return _origXHRSend.apply(this, arguments);
    };

    /* Events */
    document.addEventListener('cart:updated', function(){ open(); });
    document.addEventListener('click', function(e){
      var t = e.target.closest('[data-cart-toggle]');
      if (t) { e.preventDefault(); open(); }
    });

    load();
  }

  /* Boot */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
